import { $t } from '@/i18n';
import { StreamParser } from '../ai-stream-parser/StreamParser';
import { PATH_PREFIX } from '@/config/constant';
import { getTraceIdHeaders, AI_MODULE_MAP } from '@/modules/ai/helper';
import { STAINLESS_NULL_HEADERS } from '@/utils/openai-sdk';
import OpenAI from 'openai';
import { createWujiAI } from '@tencent/wuji-utils';
let openai = null;
function getOpenAiInstance() {
    let projectId = '';
    let env = 'dev';
    if (window?.RUNTIME_CONFIGS) {
        ({ projectId, env } = window.RUNTIME_CONFIGS);
    }
    else {
        const query = new URLSearchParams(window.location.search);
        projectId = query.get('projectId') || query.get('projectid') || '';
    }
    if (!projectId || !env)
        return;
    return new OpenAI({
        apiKey: '',
        baseURL: `${window.location.origin}${PATH_PREFIX}/api/xy/runtime/llm`,
        dangerouslyAllowBrowser: true,
        defaultHeaders: {
            ...STAINLESS_NULL_HEADERS,
            'xy-project-id': projectId,
            'xy-env': env,
            ...getTraceIdHeaders(AI_MODULE_MAP.RUNTIME_AI_SDK),
        },
    });
}
function initByImport() {
    openai = getOpenAiInstance();
}
class BrowserOpenAIClientProvider {
    getClient() {
        if (!openai)
            initByImport();
        return openai;
    }
}
const browserProvider = new BrowserOpenAIClientProvider();
export const wujiAI = createWujiAI(() => browserProvider);
const AI_NOT_READY = $t('k_d373770d');
/** model、stream 由代理处理，调用方带上时丢掉。 */
function toSystemOneBody(params) {
    const source = params && typeof params === 'object' ? params : {};
    const body = { ...source };
    delete body.model;
    delete body.stream;
    return body;
}
async function systemone(params) {
    const client = browserProvider.getClient();
    if (!client)
        throw new Error(AI_NOT_READY);
    return client.post('/systemone', { body: toSystemOneBody(params) });
}
export function getLLMInstance() {
    return new Proxy({}, {
        get(target, prop) {
            if (prop === 'init') {
                return () => initByImport();
            }
            if (prop === 'StreamParser') {
                return StreamParser;
            }
            if (prop === 'systemone') {
                return systemone;
            }
            return wujiAI[prop];
        },
    });
}
